<div class="scheduler p-3">
   <!-- Show sign-in if not signed in -->
   <div
      *ngIf="!isSignedIn"
      class="mb-3 sign-in-button">
      <button
         type="button"
         class="v-button v-button-md v-green"
         (click)="signIn()">
         Sign In
      </button>
   </div>

   <!-- Form after sign-in -->
   <div
      *ngIf="isSignedIn"
      class="grid gap-3">
      <!-- Display current user -->
      <div class="col-12">
         <p class="mb-2">
            <strong>Signed in as:</strong>
            {{ currentUser?.displayName }}
         </p>
      </div>

      <!-- Subject field -->
      <div class="col-12 scheduler-row">
         <label class="block mb-1">Subject</label>
         <input
            disabled
            pInputText
            type="text"
            class="subject-input"
            [(ngModel)]="subject"
            placeholder="Meeting Scheduler - Teams Meeting" />
      </div>

      <!-- Attendee search (PrimeNG AutoComplete) -->
      <!-- Attendee search (PrimeNG AutoComplete) -->
      <div class="col-12 scheduler-row">
         <label class="block mb-1">Attendees</label>
         <p-autoComplete
            class="attendee-input"
            [(ngModel)]="attendeeUsers"
            (ngModelChange)="onAttendeeChanged($event)"
            [suggestions]="userSuggestions"
            (completeMethod)="onUserComplete($event)"
            field="displayName"
            [minLength]="2"
            [multiple]="true"
            [forceSelection]="true"
            [dropdown]="true"
            placeholder="Type names...">
            <ng-template
               let-u
               pTemplate="item">
               <div class="scheduler-dropdown-item">
                  <span style="font-size: 14px; font-weight: 600">{{ u.displayName }}</span>
                  <span style="font-size: 12px; font-weight: normal">{{ u.userPrincipalName }}</span>
               </div>
            </ng-template>
         </p-autoComplete>
      </div>

      <!-- Date -->
      <div class="col-12 scheduler-row">
         <label class="block mb-1">Date</label>
         <p-datepicker
            [(ngModel)]="meetingDate"
            (onSelect)="onDateSelected($event)"
            placeholder="Select a date"
            [showIcon]="true"
            [minDate]="minCalendarDate"
            [maxDate]="maxCalendarDate"
            [defaultDate]="minCalendarDate"
            dateFormat="yy-mm-dd"
            appendTo="body"
            class="mini-calendar"></p-datepicker>
      </div>

      <!-- Available times -->
      <div class="col-12 scheduler-row">
         <label class="block mb-0">Available Times</label>
         <p
            *ngIf="!meetingDate"
            class="text-muted mt-1">
            Please select a date
         </p>

         <div
            *ngIf="meetingDate && availableTimes.length > 0"
            class="available-times">
            <span class="small text-muted mb-1">
               Times below are in your selected timezone,
               <i>{{ selectedTimeZone }}</i>
            </span>
            <div>
               <button
                  type="button"
                  *ngFor="let t of availableTimes"
                  (click)="!t.disabled && (startTime = t.value)"
                  [disabled]="t.disabled"
                  [class.selected]="startTime === t.value"
                  class="time-box">
                  {{ t.label }}
               </button>
            </div>
         </div>

         <p
            *ngIf="meetingDate && availableTimes.length === 0"
            class="text-muted mt-1">
            There are no available times on the selected date
         </p>
      </div>

      <!-- Time Zone -->
      <div class="tdRow">
         <div class="col-6 scheduler-row">
            <label class="block mb-1">Time zone</label>
            <p-select
               [options]="timeZoneOptions"
               [(ngModel)]="selectedTimeZone"
               (ngModelChange)="onTimeZoneChanged($event)"
               optionLabel="label"
               optionValue="value"
               appendTo="body"
               class="w-15rem"></p-select>
         </div>

         <!-- Duration -->
         <div class="col-6 scheduler-row">
            <label class="block mb-1">Duration</label>
            <p-select
               [options]="durationOptions"
               [(ngModel)]="duration"
               (ngModelChange)="onDurationChanged()"
               optionLabel="label"
               optionValue="value"
               appendTo="body"
               placeholder="Select duration"></p-select>
         </div>
      </div>

      <div class="col-12 scheduler-button-row">
         <button
            *ngIf="inModal"
            type="button"
            class="v-button v-button-md v-green"
            (click)="scheduleMeeting()"
            [disabled]="!attendeeUsers || attendeeUsers.length === 0 || !meetingDate || !startTime || loading">
            <span *ngIf="!loading">Schedule Meeting</span>
            <span *ngIf="loading">
               <i class="pi pi-spin pi-spinner mr-2"></i>
               Scheduling...
            </span>
         </button>

         <button
            *ngIf="!inModal"
            type="button"
            class="v-button v-button-md v-green"
            (click)="scheduleMeeting()"
            [disabled]="!attendeeUsers || attendeeUsers.length === 0 || !meetingDate || !startTime || loading">
            <span *ngIf="!loading">Schedule Meeting</span>
            <span *ngIf="loading">
               <i class="pi pi-spin pi-spinner mr-2"></i>
               Scheduling...
            </span>
         </button>
      </div>

      <!-- Result -->
      <div
         *ngIf="result"
         class="meeting-result mt-3 fade-in">
         <h5>Meeting Created!</h5>
         <p>
            <strong>Subject:</strong>
            {{ result.subject }}
         </p>
         <p>
            <strong>Starts:</strong>
            {{ result.start.dateTime | date : "short" }}
         </p>
         <p>
            <strong>Ends:</strong>
            {{ result.end.dateTime | date : "short" }}
         </p>
         <div>
            <strong>Attendees:</strong>
            <div *ngFor="let attendee of attendeeUsers">{{ attendee.displayName }} ({{ attendee.userPrincipalName }})</div>
            <div>{{ currentUser["displayName"] }} ({{ currentUser["workEmail"] }})</div>
         </div>
      </div>
   </div>
</div>
